export default __webpack_public_path__ + "static/media/fixed-com2.9170ca35.jpeg";